import React from "react";
import { Form, Row, Col, Input, Rate, message } from "antd";
import styles from "./feedback.module.css";
import "./feedback.css";
import {sendFeedback} from '../../util/auth';

const { TextArea } = Input;

const formItemPrefix = "form_feedback_";
const itemNames = {
  name: "name",
  email: "email",
  organization: "organization",
  rate: "rate",
  feedback: "feedback",
}

class LocalFormFeedback extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.handleSubmit = this.handleSubmit.bind(this);
    this.formItemChange = this.formItemChange.bind(this);
  }

  componentDidMount() {
    // To disabled submit button at the beginning.
    //this.props.form.validateFields();
  }

  formItemChange = itemName => e => {
    let newValue = null;

    switch (itemName) {
      case itemNames.name:
        newValue = { "name": e.target.value };
        break;
      case itemNames.email:
        newValue = { "email": e.target.value };
        break;
      case itemNames.organization:
        newValue = { "organization": e.target.value };
        break;
      case itemNames.rate:
        newValue = { "rate": e };
        break;
      case itemNames.feedback:
        newValue = { "feedback": e.target.value };
        break;
    }

    this.props.form.setFieldsValue(newValue);

    let isErrors = false;

    this.props.form.validateFields((valerr, values) => {
      if (valerr) {
        isErrors = true;
      }
    });

    this.props.formHasErrors(isErrors);
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        sendFeedback(values, ()=>{
          message.success("Отзыв отправлен");
        })

        this.props.form.resetFields();
        this.props.formHasErrors(true);
      }
      else {
        message.warning("Не все поля заполнены верно");
      }
    });
  };

  validateStatusGet(name, help) {
    const { isFieldTouched, getFieldError } = this.props.form;
    const itemStatus = isFieldTouched(name) && getFieldError(name);
    let val = "";

    if (help) {
      val = itemStatus || "";
    } else {
      val = itemStatus ? "error" : "";
    }

    return val;
  }

  render() {
    const { getFieldDecorator, getFieldsError } = this.props.form;

    const layout = {
      labelCol: { span: 10 },
      wrapperCol: { span: 12 }
    };

    return (
      <div >
        <div style={{ margin: "0.5em 0em 0.65em 1.5em" }}>
          Свои отзывы и предложения о работе интернет-службы «Теплоинформ» Вы
          можете оставить, заполнив форму:
        </div>
        <div className="formWrapper formWrapperInline">
          <Form
            id="pagesFeedbackForm"
            layout="horizontal"
            onSubmit={this.handleSubmit}
            hideRequiredMark={true}
            width="auto"
            style={{ marginLeft: "1.5em" }}>
            <Row>
              <Col span={12}>
                <Form.Item
                  {...layout}
                  colon={false}
                  label={<span
                    style={{ paddingRight: "0.5em", width: "7.9em", textAlign: "right", display: "inline-block" }}>
                    <span style={{ color: "red" }}>*</span>ФИО:</span>}
                  validateStatus={this.validateStatusGet(itemNames.name, false)}
                  help={this.validateStatusGet(itemNames.name, true)}
                  style={{
                    display: "inline-block",
                    fontFamily: "Open Sans",
                    fontSize: "0.88vw",
                    marginBottom: "0px",
                  }}
                >
                  {getFieldDecorator(itemNames.name, {
                    rules: [
                      {
                        type: "string",
                        max: 250,
                        message: "Неверный формат"
                      },
                      {
                        required: true,
                        message: "Необходимо указать имя",
                        whitespace: true
                      }
                    ],
                    onChange: this.formItemChange(itemNames.name),
                  })(<Input style={{ width: "14em" }} />)}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  colon={false}
                  {...layout}
                  label={<span
                    style={{ paddingRight: "0.5em", width: "7.9em", textAlign: "right", display: "inline-block" }}>
                    <span style={{ color: "red" }}>*</span>E-mail:</span>}
                  validateStatus={this.validateStatusGet(itemNames.email, false)}
                  help={this.validateStatusGet(itemNames.email, true)}
                  style={{
                    display: "inline-block",
                    marginBottom: "0px",
                  }}
                >
                  {getFieldDecorator(itemNames.email, {
                    rules: [
                      {
                        type: "email",
                        message: "Некорректный формат"
                      },
                      {
                        required: true,
                        message: "Необходимо указать e-mail"
                      }
                    ],
                    onChange: this.formItemChange(itemNames.email),
                  })(<Input style={{ width: "14em" }} />)}
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <Form.Item
                  colon={false}
                  {...layout}
                  label={<span
                    style={{ paddingRight: "0.5em", width: "7.9em", textAlign: "right", display: "inline-block" }}>
                    <span style={{ color: "red" }}>*</span>Организация:</span>}
                  validateStatus={this.validateStatusGet(itemNames.organization, false)}
                  help={this.validateStatusGet(itemNames.organization, true)}
                  style={{
                    display: "inline-block",
                    marginBottom: "0px"
                  }}
                >
                  {getFieldDecorator(itemNames.organization, {
                    rules: [
                      {
                        type: "string",
                        max: 250,
                        message: "Превышена максимальная длина"
                      },
                      {
                        required: true,
                        whitespace: true,
                        message: "Необходимо указать название вашей компании"
                      }
                    ],
                    onChange: this.formItemChange(itemNames.organization),
                  })(<Input style={{ width: "14em" }} />)}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  {...layout}
                  colon={false}
                  label={<span
                    style={{ paddingRight: "0.5em", width: "7.9em", textAlign: "right", display: "inline-block" }}>
                    Оценка:</span>}

                  validateStatus={this.validateStatusGet(itemNames.rate, false)}
                  help={this.validateStatusGet(itemNames.rate, true)}
                  className={styles.scoreContainer}
                  style={{
                    display: "inline-block",
                    marginBottom: "0px"
                  }}
                >
                  {getFieldDecorator(itemNames.rate, {
                    initialValue: 0,
                    onChange: this.formItemChange(itemNames.rate),
                  })(<Rate style={{ color: "#fca25c" }} />)}
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col span={24}>
                <Form.Item
                  className={styles.feddbackItem}
                  colon={false}
                  {...layout}
                  label={<span
                    style={{ paddingRight: "0.5em", width: "7.9em", textAlign: "right", display: "inline-block" }}>
                    <span style={{ color: "red" }}>*</span>Отзыв:</span>}
                  validateStatus={this.validateStatusGet(itemNames.feedback, false)}
                  help={this.validateStatusGet(itemNames.feedback, true)}
                  style={{
                    display: "inline-block",
                    paddingTop: "1vh",
                  }}
                >
                  {getFieldDecorator(itemNames.feedback, {
                    rules: [
                      {
                        type: "string",
                        max: 2000,
                        message: "Превышена максимальная длина"
                      },
                      {
                        required: true,
                        whitespace: true,
                        message: "Необходимо добавить отзыв"
                      }
                    ],
                    onChange: this.formItemChange(itemNames.feedback),
                  })(
                    <TextArea
                      rows={1}
                      style={{ minHeight: "4em", fontSize: "0.8vw", width: "42em" }}
                    />
                  )}
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    );
  }
}

const FormFeedback = Form.create({
  name: "form_feedback"
})(
  LocalFormFeedback
);


export default FormFeedback;
